export default __webpack_public_path__ + "12137619eba4f1b3e7b178666f8725b4.svg";